import React, { useState, useEffect } from 'react'

import TableRow from './TableRow'
import styled from 'styled-components'

function Table({ products = [], filters, cart, handleCart, categoryId, subCategory = null }) {
  const totalPrice = () => {
    let result = 0

    if (cart.length != 0) {
      let filterCart = []

      if (subCategory) {
        filterCart = cart.filter(el => el.subCategory === subCategory)
      } else {
        filterCart = cart.filter(el => el.category_id === categoryId)
      }

      const totalCartByCategory = filterCart.map(product => product.totalPrice)

      if (totalCartByCategory.length != 0) {
        result = totalCartByCategory.reduce((acc, cur) => {
          return acc + cur
        })
      }
    }

    return result
  }

  function sortByPrice(arr) {
    const newArr = [...arr]

    // newArr.sort((a, b) =>
    //   (a.price / a.packing / a.consumption).toFixed(2) > (b.price / b.packing / b.consumption).toFixed(2) ? 1 : -1,
    // )

    newArr.sort((a, b) => (a.price > b.price ? 1 : -1))

    return newArr
  }

  return (
    <Wrap>
      <Inner>
        <TableWrap>
          <TableRow mod={'header'} />
          {products.length != 0 &&
            sortByPrice(products).map((row, idx) => (
              <TableRow
                data={row}
                key={row.id}
                filters={filters}
                cart={cart}
                handleCart={handleCart}
                active={cart.some(product => product.id === row.id && product.category_id === categoryId)}
                currentCategory={categoryId}
                subCategory={subCategory}
              />
            ))}
        </TableWrap>
      </Inner>
      {products.length != 0 ? (
        <Footer>
          <Footer.Name>Итого</Footer.Name>
          <Footer.Total>{totalPrice().toFixed(2)} byn</Footer.Total>
        </Footer>
      ) : (
        <EmptyData>
          К сожалению, по заданным параметрам, нет материалов на данный слой. Измените параметры
          поиска или обратиться к нашему специалисту
          {/*Товаров не найдено*/}
        </EmptyData>
      )}
    </Wrap>
  )
}

export default Table
const EmptyData = styled.div`
  display: flex;
  padding: 28px 34px;
  font-weight: bold;
  font-size: 16px;
  color: #ccc;
`
const Wrap = styled.div`
  background: #fff;
`
const Inner = styled.div`
  overflow: hidden;
  overflow-x: auto;
`
const TableWrap = styled.div`
  display: table;
  width: 100%;
  padding-top: 24px;
`
const Footer = styled.div`
  display: flex;
  padding: 28px 34px;
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;
  color: #333333;
`
Footer.Name = styled.div`
  padding-right: 25px;
`
Footer.Total = styled.div`
  margin-left: auto;
`
